import { DepositBehavior, FlashDesignSize } from '@prisma/client';

export const FLASH_DESIGN_SIZE_OPTIONS: {
  value: FlashDesignSize;
  label: string;
  description: string;
}[] = [
  {
    value: 'SMALL',
    label: 'Small',
    description: 'Less than 2×2 inches.',
  },
  {
    value: 'MEDIUM',
    label: 'Medium',
    description: 'Less than 4×4 inches.',
  },
  {
    value: 'LARGE',
    label: 'Large',
    description: 'Less than 6×6 inches.',
  },
  {
    value: 'EXTRA_LARGE',
    label: 'Extra large',
    description: '7+ inches.',
  },
];

export const FLASH_DESIGN_DEPOSIT_OPTIONS: {
  value: DepositBehavior;
  label: string;
  description: string;
}[] = [
  {
    value: 'NONE',
    label: 'No deposit required',
    description: 'Clients can book without paying upfront.',
  },
  {
    value: 'FLAT_FEE',
    label: 'Charge a flat deposit fee',
    description: 'Collect a fixed deposit at booking time.',
  },
  {
    value: 'PERCENTAGE',
    label: 'Charge a % of the estimate',
    description: 'Collect a percentage of the estimated total.',
  },
  {
    value: 'FULL',
    label: 'Charge full estimate up-front',
    description: 'Collect the full estimated total at booking time.',
  },
];

export const FLASHBOOK_SETTINGS_DEFAULTS = {
  enableDirectBookings: true,
  depositBehavior: 'NONE' as DepositBehavior,
  depositAmount: 0,
  depositPercentage: 0,
};
